function phoneFilter(text) {
  return text
    .replace(/[^0-9]/g, '')
    .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2 - $3')
}

export function registerFilters(vue) {
  vue.filter('phone', (text) => phoneFilter(text))
}
